export default "__VITE_ASSET__hit9JNvx__"